import { ButtonHTMLAttributes, ReactNode } from 'react';
import Loader from './Loader';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'danger' | 'link';
    loading?: boolean;
    children: ReactNode;
}

const Button = ({ variant = 'primary', loading = false, children, disabled, className, ...props }: ButtonProps) => {
    const baseClass = `${variant}-button`;
    const classes = className ? `${baseClass} ${className}` : baseClass;

    return (
        <button className={classes} disabled={disabled || loading} {...props} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', ...props.style }}>
            {loading && <Loader size={16} color="currentColor" style={{ marginRight: '0.5rem' }} />}
            {children}
        </button>
    );
};

export default Button;
